import { GenericSurveyPreview } from 'features/subscription-process/profiling-process/components/Survey/GenericSurveyPreview';
import GenericTabs from 'components/navigation/Tabs/Tabs';
import { NsKey } from 'enums/NsKey';
import { ContextCode, SurveyName, useGenericSurvey } from 'features/subscription-process/profiling-process/hooks/useGenericSurvey';
import { ProfilingMode } from 'features/subscription-process/profiling-process/slices/types/enums';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { useEffect, useMemo, useState } from 'react';
import { RiskRealEstate } from './RiskRealEstate';
import { RiskParc } from './RiskParc';
import { useQuoteContractualizationData } from '../../store';

export const UpiRisk: React.FC = () => {
  const quoteData = useQuoteContractualizationData();
  const { t } = useDynamicTranslation([NsKey.RealEstate, NsKey.Common])
  const [active, setActive] = useState<number | string>(1);
  const { mapToSurveyFormValue, initSurvey } = useGenericSurvey()

  // Mode parc : les biens couverts sont listés dans parcRealEstates (realEstate reste vide)
  const isParc = !!quoteData?.parc;

  useEffect(() => {
    initSurvey(ContextCode.RealEstate, SurveyName.RealEstate, ProfilingMode.AutoAdvance)
  }, [initSurvey]);

  const surveyForm = useMemo(() => {
    if (quoteData?.realEstate?.surveyAnswers)
      return mapToSurveyFormValue(quoteData.realEstate.surveyAnswers)
    return undefined
  }, [quoteData?.realEstate, mapToSurveyFormValue])

  return (
    <GenericTabs defaultTab={active} onChange={setActive}>
      <GenericTabs.Item
        label={t(isParc ? "REAL_ESTATE.SECTIONS.PARC_INFOS" : "REAL_ESTATE.SECTIONS.REAL_ESTATE_INFOS")}
        value={1}
      />
      <GenericTabs.Content value={1}>
        {isParc ? <RiskParc /> : <RiskRealEstate />}
      </GenericTabs.Content>
      {!isParc && (
        <>
          <GenericTabs.Item
            label={t("COMMON.SURVEY_FORM")}
            value={2}
          />
          <GenericTabs.Content value={2}>
            <GenericSurveyPreview surveyForm={surveyForm} />
          </GenericTabs.Content>
        </>
      )}
    </GenericTabs>
  );
};
